export default __webpack_public_path__ + "static/media/mujer-senalando.065876c4.png";